import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';

class StaticButton extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <button type="button" {...props} />;
	}
}

export default class Footer extends BaseComp.default {
	renderLinks(items, type) {
		const base = super.renderLinks(items, type);
		const usingOneTrust = accessNested(this.props, 'store.appData.options.oneTrustCookieConsent.scripts');

		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		const underAge = ageGateEnabled && !isOfAge;

		if (type !== 'link' || !usingOneTrust || underAge) {
			return base;
		}

		let cookieLinkText = '';

		if (typeof window !== 'undefined') {
			cookieLinkText = window.OneTrust?.GetDomainData()?.AlertMoreInfoText;
		}

		if (Store.get().appData.footer.defaultFooter.noParamountExtraLink) {
			return base;
		}

		return [].concat(base, (
			<li class={s.linkWrapper} key="onetrust-manage-cookies">
				<StaticButton
					class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
					role="button"
				>
					{cookieLinkText}
				</StaticButton>
			</li>
		));
	}
}
